var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"hidden-sm-and-down",staticStyle:{"float":"right","margin-left":"8px"},attrs:{"size":"mini","type":"success","to-url":_vm.toUrl},on:{"click":_vm.onClick}},[_c('i',{staticClass:"fas fa-question"}),_c('span',{staticClass:"hidden-sm-and-down"},[_vm._v(" Tutorial")])])
}
var staticRenderFns = []

export { render, staticRenderFns }